import './FrameworksExplorerPage.css';

import React, { useState } from 'react';
import Banner from '../../b2b-common/Banner';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';
import useFetchAllFrameworks from '../hooks/useFetchAllFrameworks';
import ElementsCarousel from '../../b2b-common/ElementsCarousel';
import FrameworkCard from '../components/FrameworkCard';
import { CircularProgress } from '@mui/material';
import FrameworkSearchForm from '../components/FrameworkSearchForm';
import B2BElementsExplorer from '../../b2b-common/B2BElementsExplorer';
import { getFrameworkSuitte } from '../components/helper';
import IndicatorCard from '../../b2b-indicators/components/IndicatorCard';

const FrameworksExplorerPage = ({showDetails = false}) => {
    const { t } = useB2BTranslation('b2b-frameworks');

    const { frameworks, isFetching, error } = useFetchAllFrameworks();
    const [selectedFramework, setSelectedFramework] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [refresh, setRefresh] = useState(false);
    const [isSearching, setIsSearching] = useState(false);
    const [pagesCount, setPagesCount] = useState(0);
    const [indicatorData, setIndicatorData] = useState(null);

    const handleSelectedFramework = (framework) => {
        const fw = framework.props.framework;
        setSelectedFramework(fw);
    }

    const handleSelectedFrameworkIndicator = (indicator) => {
        console.log('handleSelectedFrameworkIndicator: ', indicator);
    }

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
        setRefresh(true);
    }

    return (
        <div className='frameworks-explorer-page-container' >
            <Banner message={t('Framework indicators')} headingLevel='h1' underline={false} />
            {isFetching ? (
                <div className='spinner-container'>
                    <CircularProgress />
                </div>
            ) : (
                frameworks && (
                    <ElementsCarousel
                        elements={frameworks.map(framework =>
                            <FrameworkCard key={`${framework.frameworkMicroserviceAcronym}_${framework.frameworkId}`} framework={framework} className={'fw-card-in-explorer jb_theme_01'} />
                        )}
                        onElementSelect={handleSelectedFramework}
                        className={'b2b-frameworks-explorer-carousel'}    
                    />
                )
            )}
            {selectedFramework && (
                <>
                    {showDetails && (
                        <div className='search-framework-indicator-selected-framework'>
                            <h3>{selectedFramework.frameworkName}</h3>
                            <p>{selectedFramework.frameworkDescription}</p>
                        </div>
                    )}
                    <div className='search-framework-indicator-selected-framework-indicators-explorer'>
                        <FrameworkSearchForm
                            frameworkSuite={getFrameworkSuitte(selectedFramework)}
                            title={''}
                            framework={selectedFramework}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            refresh={refresh}
                            setRefresh={setRefresh}
                            isSearching={isSearching}
                            setIsSearching={setIsSearching}
                            setIndicatorsData={setIndicatorData}
                            setPagesCount={setPagesCount}
                            className={'b2b-search-form-vue-inspired-01'}
                        />
                        {indicatorData && (
                            <B2BElementsExplorer
                                // title={t('Selected framework indicators results')}
                                isSearching={isSearching}
                                elementsData={indicatorData}
                                pagesCount={pagesCount}
                                currentPage={currentPage}
                                handlePageChange={handlePageChange}
                                // pageNumberLoading={currentPage}
                                className="frameworks-indicators-explorer"
                                onSelectedFrameworkIndicator={handleSelectedFrameworkIndicator}
                                ElementComponent={IndicatorCard}
                                elementComponentPropName='indicator'
                                otherComponentProps={{
                                    className: 'custom-indicator-card b2b-indicator-theme-light-01',
                                    showMoreButton: false,
                                }}
                            />
                        )}
                    </div>
                </>
            )}
        </div>
    );
};

export default FrameworksExplorerPage;